import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import { Can } from '../Can'
import { SmallButton } from '../common/forms/FormElements';
import CommonContext from '../Common';
import { CircularProgress } from '@material-ui/core';


export class EmployeeAddressInfo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            showAddressForm: true
        }
    }

    componentDidMount() {
        this.populateState();
    }

    async populateState() {
        this.setState({
            loading: false
        });
    }

    render() {
        if (this.state.loading || !this.props.userPermissions.length) {
            return (<CircularProgress color="secondary" variant="indeterminate" />)
        } else {

            return (
                <CommonContext.Consumer>
                    {(value) => {
                        return (
                            <>
                                <Row className="pb-1">
                                    <Col>
                                        <div className="d-flex flex-row align-items-center justify-content-end">
                                            <Can I="edit" a="employee_home_address">
                                                <SmallButton
                                                    disabled={!!value.formIsOpen}
                                                    onClick={() => { this.props.onAddAddress('home') }}
                                                >
                                                    <i className="fa fa-plus-circle fa-md mr-2" />Add Home Address
                                                </SmallButton>
                                            </Can>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <table className="table table-sm table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Address</th>
                                                    <th>Type</th>
                                                    <Can I="edit" a="employee">
                                                        <th className="text-center" style={{ width: '30px' }}></th>
                                                    </Can>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!(this.props.addresses ?? []).length
                                                    ? <tr><td colSpan="4" className="text-center">No addresses found.</td></tr>
                                                    : this.props.addresses.map((address, i) => {

                                                        return (
                                                            <tr key={address.id}>
                                                                <td>{`${address.address1}${address.address2 ? ' ' + address.address2 : ''} ${address.city}, ${address.state} ${address.zip} `}</td>
                                                                <td></td>
                                                                <td className="text-center" style={{ width: '30px' }}>
                                                                    {
                                                                        <Button
                                                                            disabled={!!value.formIsOpen}
                                                                            type="button"
                                                                            color="outline-primary"
                                                                            onClick={() => this.props.onEditAddress(address)}
                                                                            size="sm"
                                                                        >
                                                                            Edit
                                                                        </Button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                            </tbody>
                                        </table>
                                    </Col>
                                </Row>
                            </>
                        )
                    }}
                </CommonContext.Consumer>
            );
        }
    }
}

EmployeeAddressInfo.contextType = CommonContext;